<template>
  <v-dialog v-model="openDialog" persistent max-width="800px">
    <v-card color="warning">
      <v-card-title class="pl-6 pt-4 d-flex align-center">
        <v-icon size="24" class="mr-2 text-custom-on-warning">mdi-alert</v-icon>
        <span class="text-h5 text-custom-on-warning">Rolle löschen</span>
      </v-card-title>
      <v-card-text class="pt-0">
        <span class="text-h6">
          Sind Sie sicher, dass Sie die Rolle
          <strong>{{ toDelete.name }}</strong> löschen wollen?
        </span>
      </v-card-text>
      <v-card-actions class="mr-4 mb-2">
        <v-spacer />
        <v-btn
          variant="elevated"
          color="primary"
          :loading="inProgress"
          @click="onDelete"
          >Ja</v-btn
        >
        <v-btn variant="outlined" class="ml-3 text-custom-on-warning" @click="closeDialog"
          >Nein</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiRolesService from "@/services/api/ApiRolesService";

export default {
  name: "roleDeleteConformationDialog",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    toDelete: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      inProgress: false,
    };
  },
  computed: {
    openDialog: {
      get() {
        return this.open;
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    async onDelete() {
      this.inProgress = true;
      // TODO: darf nicht gelöscht werden, wenn Benutzer noch diese Rolle haben.
      await ApiRolesService.deleteRole(this.toDelete);
      this.inProgress = false;
      this.closeDialog();
    },
  },
};
</script>

<style scoped></style>
